import React, { useState } from 'react';
import { FormControl, InputLabel, OutlinedInput } from '@mui/material';
import { useIntl } from 'react-intl';
import { PatternFormat } from 'react-number-format';
import { useSelector } from 'react-redux';

const VerificationPhoneInput = ({ value, onValueChange, isError = false, errorText, hasSendPhone, handleSendPhone, autoFocus = false }) => {
  const { formatMessage } = useIntl();
  const [isFocus, setIsFocus] = useState(false);
  const { country } = useSelector(state => state.settings);

  return (
    <FormControl
      error={isError}
      fullWidth
      variant="outlined"
      sx={{
        '& label': {
          color: '#000',
          fontFamily: 'Pretendard',
        },
        '& label.Mui-focused': {
          color: '#000',
        },
        '& label.Mui-error': {
          color: '#000',
        },

        '& .MuiOutlinedInput-root': {
          fieldset: {
            borderRadius: '10px',
            border: '1px solid #ddd',
          },
          '&:hover fieldset': {
            borderColor: '#000',
          },
          '&.Mui-focused fieldset': {
            border: '1px solid #000',
          },
          '&.Mui-error fieldset': {
            border: '1px solid #FF4B4B',
          },
        },
      }}
    >
      {(isFocus || value) && <InputLabel htmlFor={'consult.customer.create.phone'}>{formatMessage({ id: 'consult.customer.create.phone' })}</InputLabel>}
      <PatternFormat
        id="consult.customer.create.phone"
        value={value}
        onValueChange={onValueChange}
        format={country === 'ko' ? '###-####-####' : '###########'}
        type={'text'}
        placeholder={formatMessage({ id: 'consult.customer.create.phone' })}
        label={formatMessage({ id: 'consult.customer.create.phone' })}
        onFocus={() => {
          setIsFocus(true);
        }}
        onBlur={() => {
          setIsFocus(false);
        }}
        customInput={OutlinedInput}
        inputProps={{
          style: {
            color: '#222',
            fontFamily: 'Pretendard',
            fontSize: '15px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: 'normal',
            padding: '15px',
          },
          tabIndex: 0,
        }}
        endAdornment={
          <div
            className="cursor-pointer no-drag"
            style={{ padding: '8px 10px', borderRadius: '8px', backgroundColor: '#E6F0FD', color: '#0567f9', fontSize: '13px', fontWeight: 400, lineHeight: 'normal', whiteSpace: 'nowrap' }}
            onClick={handleSendPhone}
          >
            {hasSendPhone ? formatMessage({ id: 'signIn.join.phone.verify.resend' }) : formatMessage({ id: 'signIn.join.phone.verify.send' })}
          </div>
        }
        onKeyPress={e => {
          if (e.key === 'Enter') {
            handleSendPhone();
          }
        }}
        autoFocus={autoFocus}
      />
      {isError && errorText && <div className="error-text">{errorText}</div>}
    </FormControl>
  );
};

export default VerificationPhoneInput;
